import baseStyles from '../Base/Base.styles';
import merge from 'lodash/merge';
import baseButtonStyles from '../BaseButton/BaseButton.styles';
import {parseResponsiveProperty} from '@converdy/styles';

export default (props) => {
  const {base, height, button} = props;

  let jss = {
    root: {
      ...baseStyles(base),
      '& .baseButton': baseButtonStyles(button),
      ...parseResponsiveProperty((v) => {
        return v
          ? {
              '--height': `${v}px`,
            }
          : {};
      }, height),
    },
  };

  return jss;
};
